/** Dark one-line code example. A call like `search_budget({...})` gets a tool_use label and a yellow tool name. */
export function CodeBar({ code, left, top, width }: { code: string; left: number; top: number; width: number }) {
  const call = /^([A-Za-z_][\w.]*)(\(.*)$/s.exec(code.trim());
  return (
    <div className="abs code-bar" style={{ left, top, width }}>
      {call ? (
        <>
          <span className="code-kind">tool_use</span>
          <span>
            <span className="code-tool">{call[1]}</span>
            {call[2]}
          </span>
        </>
      ) : (
        <span>{code}</span>
      )}
    </div>
  );
}
